var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"may-like",class:{en: _vm.$i18n.locale === 'en'}},[_c('span',{staticClass:"may-like-triangle"}),_vm._v(" "),_c('span',{staticClass:"may-like-text"},[_vm._v(_vm._s(_vm.$t('main.YOU_MAY_LIKE')))])])}
var staticRenderFns = []

export { render, staticRenderFns }